import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import useAutenticacaoJwt from "@auth/services/jwt/useAutenticacaoJwt";
import { env } from "@/configs/configEnv/env";
import { sincronizarSessaoUsertour } from "./usertour.service";
import { obterIdentidadeUsertour } from "./usertour.utils";

// ------------------------------- COMPONENT -------------------------------
export default function UsertourIntegration() {
	// ----------------------------- DERIVED STATE -----------------------------
	const { authStatus, isAuthenticated, user } = useAutenticacaoJwt();
	const navigate = useNavigate();
	const token = env.VITE_USERTOUR_TOKEN?.trim();
	const autenticado = authStatus === "authenticated" && isAuthenticated;
	const identidade = obterIdentidadeUsertour(user?.id_cad_grupo, user?.id_cad_pessoa);
	const nome = typeof user?.nome === "string" ? user.nome.trim() : undefined;

	// ------------------------------- HANDLERS -------------------------------
	const aoNavegar = useCallback(
		(url: string): void => {
			try {
				const destino = new URL(url, globalThis.location.href);
				if (destino.origin === globalThis.location.origin)
					void Promise.resolve(navigate(`${destino.pathname}${destino.search}${destino.hash}`)).catch(() => {
						console.error("Não foi possível navegar para o destino do guia Usertour.");
					});
				else globalThis.location.assign(destino.href);
			} catch {
				console.error("Não foi possível navegar para o destino do guia Usertour.");
			}
		},
		[navigate],
	);

	// -------------------------------- EFFECTS --------------------------------
	useEffect(() => {
		if (!token || !autenticado || identidade === null) {
			sincronizarSessaoUsertour(null);
			return;
		}
		sincronizarSessaoUsertour({ token, identidade, nome: nome || undefined, aoNavegar });
	}, [token, autenticado, identidade, nome, aoNavegar]);

	useEffect(() => () => sincronizarSessaoUsertour(null), []);

	// -------------------------------- RETURN --------------------------------
	return null;
}
